/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Time_Minutesago1Inputs */

const he_time_minutesago1 = /** @type {(inputs: Time_Minutesago1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`לפני ${i?.count}m`)
};

const en_time_minutesago1 = /** @type {(inputs: Time_Minutesago1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.count}m ago`)
};

/**
* | output |
* | --- |
* | "{count}m ago" |
*
* @param {Time_Minutesago1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const time_minutesago1 = /** @type {((inputs: Time_Minutesago1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Time_Minutesago1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_time_minutesago1(inputs)
	return en_time_minutesago1(inputs)
});
export { time_minutesago1 as "time_minutesAgo" }